import { gql } from '@/features/graphql/generated'

export const DeliveryTimeOfferQuery = gql(/* GraphQL */ `
    query DeliveryTimeOffer(
        $coordinates: CoordinatesInput
        $deliveryTypeCategory: DeliveryTypeCategory!
    ) {
        deliveryTimeOffer(coordinates: $coordinates, deliveryTypeCategory: $deliveryTypeCategory) {
            ...DeliveryTimeOffer
        }
    }
`)
